<router-outlet />
<p-toast position="bottom-center" />
<p-confirmDialog />

<!-- RECAPTCHA USED WITH FIREBASE FOR 2FA -->
<div class="invisible" id="recaptcha"></div>
